import { AppDispatch } from "@/app/store";
import TableList, { TableColumn } from "@/components/common/TableList";

import { Form } from "@/types/form.types";
import { Alert, CircularProgress, IconButton, Tooltip, Snackbar } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { Box } from "@mui/system";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { selectForms, selectFormsError, selectFormsLoading } from "@/features/documents/formsSelector";
import { fetchForms } from "@/features/documents/formsThunks";

interface FormsTableProps {
    onEdit?: (form: Form) => void
    onDelete?: (form: Form) => void
}
const FormatsTable: FC<FormsTableProps> = ({ onEdit, onDelete }) => {
    const dispatch = useDispatch<AppDispatch>();
    const forms = useSelector(selectForms)
    const loadingForms = useSelector(selectFormsLoading);
    const errorForms = useSelector(selectFormsError);

    useEffect(() => {
        dispatch(fetchForms());
    }, [dispatch])

    const [snackOpen, setSnackOpen] = useState(false)
    const [snackMsg, setSnackMsg] = useState('')
    const [snackSeverity, setSnackSeverity] = useState<'success' | 'error' | 'info' | 'warning'>('error')
    const showSnackbar = (msg: string, sev: 'success' | 'error' | 'info' | 'warning' = 'error') => { setSnackMsg(msg); setSnackSeverity(sev); setSnackOpen(true) }
    const handleSnackClose = () => setSnackOpen(false)

    const handleEdit = async (form: Form) => {
        try {
            onEdit?.(form)
        } catch (err) {
            console.error('Error handling edit:', err);
            showSnackbar('Error al iniciar edicion.  Por favor, intente nuevamente.', 'error');
        }

    };
    const handleDelete = (form: Form) => {
        onDelete?.(form)
    };


    const columns: TableColumn<Form>[] = [
        { key: 'name', label: 'Título', headerSx: { color: '#374151' } },
        { key: 'type', label: 'Tipo', headerSx: { color: '#374151' } },
        {
            key: 'actions', label: 'Acciones', align: 'center', width: 120, render: (f) => (
                <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center' }}>
                    <Tooltip title="Editar">
                        <IconButton
                            size="small"
                            onClick={() => handleEdit(f)}
                            sx={{ color: '#6b7280', '&:hover': { color: 'primary.main' } }}
                        >
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>

                    {/* Botón de Eliminar (NUEVO) */}
                    <Tooltip title="Eliminar">
                        <IconButton
                            size="small"
                            onClick={() => handleDelete(f)}
                            sx={{ color: '#6b7280', '&:hover': { color: '#ef4444' } }} // Color de hover rojo
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>
            ),
            cellSx: { px: 1 }
        }
    ];
    if (loadingForms) {
        return (
            <Box sx={{ p: 4, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 }}>
                <CircularProgress />
            </Box>
        )
    }
    if (errorForms) {
        return (
            <Box sx={{ p: 4 }}>
                <Alert severity="error">{errorForms}</Alert>
            </Box>
        );
    }
    return (
        <>
            <Box sx={{ py: 2, px: { xs: 2, md: 3, lg: 4 }, mg: 3, mb: 4 }}>
                <Snackbar open={snackOpen} autoHideDuration={4000} onClose={handleSnackClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                    <MuiAlert onClose={handleSnackClose} severity={snackSeverity} sx={{ width: '100%' }}>{snackMsg}</MuiAlert>
                </Snackbar>
                <TableList
                    data={forms}
                    columns={columns}
                    title="Formatos Institucionales"
                    getRowKey={(f) => f.id}
                    containerSx={{ borderRadius: 2, border: '1px solid #e5e7eb', pb: 5 }}
                    tableSx={{}}
                    headerBackground={true}
                    emptyMessage="No hay formatos registrados"
                />
            </Box>

        </>
    )
}

export default FormatsTable;